import React, {memo} from 'react';
import cn from 'classnames';
import {Icon} from 'ht-styleguide';
import styles from './serviceinfo.module.scss';
import {useResponsiveIsMobile} from '@store/client/store.responsive';

/* Types */
type ServiceInfoOptionsProps = {
  options: {
    bullet: string;
  }[];
  className?: string;
};

const ServiceInfoOptions = ({options, className}: ServiceInfoOptionsProps) => {
  /* Client Store */
  const isMobile = useResponsiveIsMobile();

  const heightAdjust = isMobile ? 24 : 40;
  const minHeight = `${options.length * 36 + heightAdjust}px`;

  return (
    <div style={{minHeight}}>
      <div className={className} data-testid="sku-services-info-options">
        {options.map((o, idx) => (
          <div style={{minHeight: '36px'}} key={`options${idx}`} className={cn('paddingBottom-small', styles.serviceItem)}>
            <Icon name="checkmark-v2" className="n700" />
            <span className="p2 n900">{o.bullet}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(ServiceInfoOptions);
